export const LOCALES = ['en', 'id', 'hi', 'ms', 'zh'] as const;

export type Locale = (typeof LOCALES)[number];

export type MessageVars = Record<string, string | number>;

export type MessageTree = {
  [key: string]: string | MessageTree;
};

export type CatalogOf<T> = {
  [K in keyof T]: T[K] extends string ? string : CatalogOf<T[K]>;
};

export function isLocale(value: string | null | undefined): value is Locale {
  return !!value && (LOCALES as readonly string[]).includes(value);
}

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  id: 'Bahasa Indonesia',
  hi: 'हिन्दी',
  ms: 'Bahasa Melayu',
  zh: '中文',
};

export const DATE_LOCALES: Record<Locale, string> = {
  en: 'en-GB',
  id: 'id-ID',
  hi: 'hi-IN',
  ms: 'ms-MY',
  zh: 'zh-CN',
};
